import { type Metric } from '../vessel_data'

export enum RudderMetric {
  rudderPort = 'rudderPort',
  rudderStbd = 'rudderStbd'
}

export type RudderMetricName = keyof typeof RudderMetric

export type RudderMetrics = Record<RudderMetricName, Metric>

export const allRudderMetricNames: RudderMetricName[] = Object.values(RudderMetric)
